import {RouteContext} from "../../RouteContext";
import {Styles} from "../common/Styles";
import {Button, Checkbox, Field, FieldProps, Input, Radio, RadioGroup} from "@fluentui/react-components";
import {Column, Row} from "../common/Layout";
import React from "react";
import {PlaceDataTransferObject} from "../../../model/dto/content/place/PlaceDataTransferObject";
import {PlaceMissionType} from "../../../constant/PlaceMissionType";
import {BitMask, isVisible} from "../../../utils/bitmask";
import {InputStringStatePair, StatePair, useError, useInputString, useStatePair} from "../../../type/States";
import {DataTransferObjectValidation, Types} from "../../../type/Types";

const json = require('json-bigint')({
    alwaysParseAsBig: false,
    useNativeBigInt: true
})

export default function Post(props: RouteContext) {
    const styles = Styles.useEditorStyles()
    const error = useError();

    const handlebitMaskValueChange = (index: number, value: string) => {
        const currentValue = Number(value);
        const nextValue = BitMask.invert(currentValue, index);
        return nextValue.toString();
    };

    const inputStates: Record<keyof PlaceDataTransferObject.Post, InputStringStatePair> = {
        isActive: useInputString(''),
        exposedAt: useInputString(''),
        placeMissionType: useInputString(''),
        placeNumber: useInputString(''),
        placeName: useInputString(''),
        placeImageUrl: useInputString(''),
        placeTelephoneNumber: useInputString(''),
        answer: useInputString(''),
        placeUrl: useInputString(''),
        attractionNameString: useInputString(''),
        keywordString: useInputString(''),
        amount: useInputString(''),
    }
    const inputValidationStates: Record<keyof PlaceDataTransferObject.Post, StatePair<FieldProps['validationState']>> = {
        isActive: useStatePair<FieldProps['validationState']>('none'),
        exposedAt: useStatePair<FieldProps['validationState']>('none'),
        placeMissionType: useStatePair<FieldProps['validationState']>('none'),
        placeNumber: useStatePair<FieldProps['validationState']>('none'),
        placeName: useStatePair<FieldProps['validationState']>('none'),
        placeImageUrl: useStatePair<FieldProps['validationState']>('none'),
        placeTelephoneNumber: useStatePair<FieldProps['validationState']>('none'),
        answer: useStatePair<FieldProps['validationState']>('none'),
        placeUrl: useStatePair<FieldProps['validationState']>('none'),
        attractionNameString: useStatePair<FieldProps['validationState']>('none'),
        keywordString: useStatePair<FieldProps['validationState']>('none'),
        amount: useStatePair<FieldProps['validationState']>('none'),
    }
    const postErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.isActive.setValue('none')
        inputValidationStates.exposedAt.setValue('none')
        inputValidationStates.placeMissionType.setValue('none')
        inputValidationStates.placeNumber.setValue('none')
        inputValidationStates.placeName.setValue('none')
        inputValidationStates.placeImageUrl.setValue('none')
        inputValidationStates.placeTelephoneNumber.setValue('none')
        inputValidationStates.answer.setValue('none')
        inputValidationStates.placeUrl.setValue('none')
        inputValidationStates.attractionNameString.setValue('none')
        inputValidationStates.keywordString.setValue('none')
        inputValidationStates.amount.setValue('none')
        try {
            const dto: PlaceDataTransferObject.Post = {
                isActive:  DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'isActive', inputStates.isActive.value, () => inputValidationStates.isActive.setValue('error')),
                exposedAt: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'exposedAt', inputStates.exposedAt.value, () => inputValidationStates.exposedAt.setValue('error')),
                placeMissionType: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'placeMissionType', inputStates.placeMissionType.value, () => inputValidationStates.placeMissionType.setValue('error')),
                placeNumber: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'placeNumber', inputStates.placeNumber.value, () => inputValidationStates.placeNumber.setValue('error')),
                placeName: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'placeName', inputStates.placeName.value, () => inputValidationStates.placeName.setValue('error')),
                placeImageUrl: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'placeImageUrl', inputStates.placeImageUrl.value, () => inputValidationStates.placeImageUrl.setValue('error')),
                placeTelephoneNumber: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'placeTelephoneNumber', inputStates.placeTelephoneNumber.value, () => inputValidationStates.placeTelephoneNumber.setValue('error')),
                answer: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'answer', inputStates.answer.value, () => inputValidationStates.answer.setValue('error')),
                placeUrl: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'placeUrl', inputStates.placeUrl.value, () => inputValidationStates.placeUrl.setValue('error')),
                attractionNameString: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'attractionNameString', inputStates.attractionNameString.value, () => inputValidationStates.attractionNameString.setValue('error')),
                keywordString: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'keywordString', inputStates.keywordString.value, () => inputValidationStates.keywordString.setValue('error')),
                amount: DataTransferObjectValidation.validate(PlaceDataTransferObject.Post.validation, 'amount', inputStates.amount.value, () => inputValidationStates.amount.setValue('error')),
            }

            fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/places`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: json.stringify(dto)
            })
            .then(async value => {
                const res = await value.json()
                console.log(res)
                if(res) window.alert("추가 되었습니다.")
            })
            .catch(postErrorState.setDefinedValue)

        } catch (error) {
            console.error(error)
        }
    }

    return <>
        <postErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.isActive}
                validationState={inputValidationStates.isActive.value}>
                <RadioGroup
                    value={inputStates.isActive.value}
                    onChange={
                        (_, data) => inputStates.isActive.setValue(data.value)
                    }>
                    <Radio value="true" label="활성화" />
                    <Radio value="false" label="비활성화" />
                </RadioGroup>
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.exposedAt}
                validationState={inputValidationStates.exposedAt.value}>
                <Input
                    value={inputStates.exposedAt.value}
                    onChange={inputStates.exposedAt.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.placeMissionType}
                validationState={inputValidationStates.placeMissionType.value}>
                <RadioGroup
                    value={inputStates.placeMissionType.value}
                    onChange={
                        (_, data) => inputStates.placeMissionType.setValue(data.value)
                    }>
                    <Radio value="1" label="플레이스 트래픽" />
                    <Radio value="2" label="플레이스 저장하기" />
                </RadioGroup>
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.placeNumber}
                validationState={inputValidationStates.placeNumber.value}>
                <Input
                    value={inputStates.placeNumber.value}
                    onChange={inputStates.placeNumber.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.placeName}
                validationState={inputValidationStates.placeName.value}>
                <Input
                    value={inputStates.placeName.value}
                    onChange={inputStates.placeName.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.placeImageUrl}
                validationState={inputValidationStates.placeImageUrl.value}>
                <Input
                    value={inputStates.placeImageUrl.value}
                    onChange={inputStates.placeImageUrl.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.placeTelephoneNumber}
                validationState={inputValidationStates.placeTelephoneNumber.value}>
                <Input
                    value={inputStates.placeTelephoneNumber.value}
                    onChange={inputStates.placeTelephoneNumber.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.answer}
                validationState={inputValidationStates.answer.value}>
                <Input
                    value={inputStates.answer.value}
                    onChange={inputStates.answer.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.placeUrl}
                validationState={inputValidationStates.placeUrl.value}>
                <Input
                    value={inputStates.placeUrl.value}
                    onChange={inputStates.placeUrl.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.attractionNameString}
                validationState={inputValidationStates.attractionNameString.value}>
                <Input
                    value={inputStates.attractionNameString.value}
                    onChange={inputStates.attractionNameString.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.keywordString}
                validationState={inputValidationStates.keywordString.value}>
                <Input
                    value={inputStates.keywordString.value}
                    onChange={inputStates.keywordString.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={PlaceDataTransferObject.Post.description.amount}
                validationState={inputValidationStates.amount.value}>
                <Input
                    value={inputStates.amount.value}
                    onChange={inputStates.amount.onChange} />
            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}